import { useEffect } from 'react';

import { IApplicationPage } from 'application/pages/types';
import AnalyticsService, { EventNameAMP, ParamNameAMP } from 'application/services/AnalyticsService';
import { useWebPlayerActionsContext } from 'application/providers/WebPlayerProvider';
import { LOGOUT_PAGE_PATH, TOP_BANNER_TYPE_CLOSED } from 'application/consts';
import { useAccountCompanyId } from 'application/hooks';
import { useAppDispatch } from 'application/providers/StoreProvider';
import { setAuthToken, clearAccountData } from 'application/store';

import { useLogout } from '@entities/auth';
import { removeTokenCookie } from '@shared/lib';

import { LocalAccessRoles } from '@shared/config';

import LoadingScreen from '@zvuk-b2b/react-uikit/ui/LoadingScreen';

const LogoutPage: IApplicationPage = () => {
  const dispatch = useAppDispatch();
  const companyId = useAccountCompanyId();

  const [request] = useLogout();

  const { stopAndClosePlayer } = useWebPlayerActionsContext();

  useEffect(() => {
    (async () => {
      try {
        await request();
      } finally {
        removeTokenCookie();
        localStorage.removeItem(TOP_BANNER_TYPE_CLOSED);
        dispatch(clearAccountData());
        dispatch(setAuthToken(undefined));
        AnalyticsService.event(EventNameAMP.USER_LOGGED_OUT, {
          [ParamNameAMP.COMPANY_ID]: companyId,
        });

        stopAndClosePlayer();
      }
    })();
  }, []);

  return <LoadingScreen />;
};

LogoutPage.config = {
  routes: [
    {
      path: LOGOUT_PAGE_PATH,
    },
  ],
  access: [LocalAccessRoles.AUTHORIZED],
};

export default LogoutPage;
